module.exports = __webpack_public_path__ + "img/empty.f74448f5.png";